module.exports = __webpack_public_path__ + "static/media/Optimus Terms and Conditions.e8a5e2d8.pdf";